












import { Component, Vue, Prop } from 'vue-property-decorator'
import { Company, FinanceInfo, CompanyRepresentativeReport } from '@/utils/Interfaces'
import BaoCaoGeneric from '@/components/BaoCaoGeneric.vue'

declare interface FormattedReport extends CompanyRepresentativeReport {
  company: Company['name'];
  finance_info: CompanyRepresentativeReport['finance_info'];
  ty_le_von_gop: CompanyRepresentativeReport['ty_le_von_gop'];
  xep_loai_doanh_nghiep_theo_gstc: CompanyRepresentativeReport['xep_loai_doanh_nghiep_theo_gstc'];
  ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach: CompanyRepresentativeReport['ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach'];
  ty_le_co_tuc: CompanyRepresentativeReport['ty_le_co_tuc'];
  so_tien_co_tuc: CompanyRepresentativeReport['so_tien_co_tuc'];
  chap_hanh_phap_luat: CompanyRepresentativeReport['chap_hanh_phap_luat'];
  pham_chat_dao_duc: CompanyRepresentativeReport['pham_chat_dao_duc'];
  xep_loai_doanh_nghiep_theo_qc: CompanyRepresentativeReport['xep_loai_doanh_nghiep_theo_qc'];
  xep_loai_NDD_doanh_nghiep: CompanyRepresentativeReport['xep_loai_NDD_doanh_nghiep'];
}


@Component({
  components: {
    BaoCaoGeneric,
  }
})
export default class BaoCaoPLDGNDD extends Vue {
  @Prop(Array) readonly reports!: Array<CompanyRepresentativeReport>

  reportType = 'BaoCaoPLDGNDD'

  headerMapper: { [index: string]: string } = {
    company: 'Công ty',
    nguoi_dai_dien: 'Người đại diện',
    chuc_danh: 'Chức danh',
    ty_le_von_gop: 'Tỷ lệ vốn góp của Tổng công ty tại các Công ty cổ phần',
    xep_loai_doanh_nghiep_theo_gstc: 'Xếp loại doanh nghiệp theo báo cáo GSTC',
    ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach: '% tỷ suất lợi nhuận thực hiện / kế hoạch',
    ty_le_co_tuc: 'Tỷ lệ cổ tức',
    so_tien_co_tuc: 'Số tiền cổ tức',
    chap_hanh_phap_luat: 'Chấp hành các quy định PL, NQ, QĐ của TCT',
    pham_chat_dao_duc: 'Phẩm chất chính trị, đạo đức, lối sống',
    xep_loai_doanh_nghiep_theo_qc: 'Xếp loại doanh nghiệp theo điều 36 quy chế',
    xep_loai_NDD_doanh_nghiep: 'Xếp loại hoạt động người đại diện DN',
  }

  formatMapper: { [index: string]: string | null } = {
    company: 'link',
    nguoi_dai_dien: 'long_text',
    chuc_danh: 'long_text',
    ty_le_von_gop: 'percentage',
    xep_loai_doanh_nghiep_theo_gstc: 'select',
    ty_suat_loi_nhuan_thuc_hien_tren_ke_hoach: 'text',
    ty_le_co_tuc: 'percentage',
    so_tien_co_tuc: 'money',
    chap_hanh_phap_luat: 'select',
    pham_chat_dao_duc: 'select',
    xep_loai_doanh_nghiep_theo_qc: 'select',
    xep_loai_NDD_doanh_nghiep: 'select',
  }

  choicesMapper: { [index: string]: unknown } = {
    xep_loai_doanh_nghiep_theo_gstc: ['A', 'B', 'C'],
    chap_hanh_phap_luat: ['A', 'B', 'C'],
    pham_chat_dao_duc: ['A', 'B', 'C'],
    xep_loai_doanh_nghiep_theo_qc: ['A', 'B', 'C'],
    xep_loai_NDD_doanh_nghiep: ['Hoàn thành tốt nhiệm vụ', 'Hoàn thành nhiệm vụ', 'Không hoàn thành nhiệm vụ'],
  }

  get formattedReports () {
    const formattedReports: Array<FormattedReport> = []

    this.reports.forEach(report => {
      // @ts-expect-error
      const formattedReport: FormattedReport = {}

      // Get company name
      const financeInfo = report.finance_info as FinanceInfo
      const company = financeInfo.company as Company
      const companyName = company.name
      formattedReport.company = companyName

      // Get remaining info
      Object.assign(formattedReport, report)
      // Remove not needed info
      delete formattedReport.finance_info
      delete formattedReport.created_at
      delete formattedReport.updated_at

      formattedReports.push(formattedReport)
    })

    return formattedReports
  }
}
